import { render, staticRenderFns } from "./Toxic.vue?vue&type=template&id=e1a31856&scoped=true"
import script from "./Toxic.vue?vue&type=script&lang=js"
export * from "./Toxic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a31856",
  null
  
)

export default component.exports